import React from 'react'
import { Position } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Icon } from '@ui'
import css from './detailsTableLabel.module.scss'

interface IProps {
  label?: React.ReactNode
  editing?: boolean
  required?: boolean
  hint?: any
}

export default function Label({ label, required, editing = true, hint }: IProps) {
  return (
    <div className={css.s_label}>
      {label}
      <Label.Hint hint={hint} />
      {!required && editing && <div className={css.s_optional}>Optional</div>}
    </div>
  )
}
interface IHintProps {
  hint?: string
}
Label.Hint = function ({ hint }: IHintProps) {
  if (!hint) return null
  return (
    <Tooltip2 content={hint} position={Position.TOP}>
      <Icon style={{ color: 'var(--grey3)' }} name="question-circle" className="ml1" />
    </Tooltip2>
  )
}
